import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { UsersService } from '../../users.service';
import { DxDataGridComponent } from 'devextreme-angular';



@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  dataSource;
  sessionId = sessionStorage.getItem('com-session-id');
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  UserIDLength;

  constructor(
    private httpclient: HttpClient,
    public sharedService: SharedService,
    public users: UsersService,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
    this.onPageLoad();
  }

  onPageLoad() {
    this.sharedService.loadingActive = true;
    const postSession = {
      SessionID: this.sessionId,
    };
    this.httpclient.post<any>(`${this.sharedService.URLnode}/utUser`, postSession).subscribe(Response => {
      console.log(Response);
      this.dataSource = Response.recordset == null ? [] : Response.recordset;
      this.dataGrid.instance.refresh();
      this.sharedService.loadingActive = false;
      this.UserIDLength = this.dataSource.length + 1;
      sessionStorage.setItem('user-length', this.UserIDLength);
    });
    this.sharedService.loadingActive = false;
  }

  clickEdit(data) {
    this.users.setNewEdit(0);
    sessionStorage.setItem('user-id', data);
  }

  clickNew() {
    this.users.setNewEdit(1);
  }

}
